(() => {
  function bind(root = document) {
    root.querySelectorAll('[data-gg-piece]').forEach(piece => {
      if (piece.dataset.ggBound) return;
      piece.dataset.ggBound = 'true';
      const image = piece.querySelector('.gg-piece__main-image');
      function showImage(src) { if (!image || !src) return; image.removeAttribute('srcset'); image.src = src; }
      piece.querySelectorAll('[data-gg-image]').forEach(button => button.addEventListener('click', () => showImage(button.dataset.ggImage)));
      const select = piece.querySelector('[data-gg-variant]');
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0], button = piece.querySelector('[data-gg-buy]');
        piece.querySelector('[data-gg-price]').textContent = option.dataset.price;
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.availableLabel;
        showImage(option.dataset.image);
        const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
      });
    });
  }
  bind(); document.addEventListener('shopify:section:load', event => bind(event.target));
})();
